import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOperatingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsxs("g", {
				className: "cls-4",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m15.69,15.16c-.29-.28-.62-.51-.96-.7-.68-.37-1.44-.57-2.23-.57s-1.56.2-2.24.57c-.33.18-.63.4-.91.66-.74.69-1.25,1.61-1.42,2.6,0,.02,0,.04.02.05l4.51,2.64h0s.01,0,.01,0c0,0,0,0,.01,0,0,0,0,0,0,0h.01s.01-.01.01-.01l4.52-2.58s.03-.03.03-.05c-.16-.99-.65-1.92-1.39-2.62Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "icon-white",
					d: "m9.46,10.2c0,1.68,1.36,3.04,3.04,3.04s3.04-1.36,3.04-3.04c0-.15-.01-.31-.04-.47,0,0,.25-.48.25-.49,0-1.79-1.46-3.25-3.25-3.25s-3.25,1.46-3.25,3.25c0,0,.25.49.25.49-.02.16-.04.32-.04.47Z"
				})]
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m15.81,15.03c-.9-.85-2.08-1.33-3.32-1.33s-2.38.45-3.27,1.28c-.77.71-1.3,1.67-1.48,2.7-.02.09.03.19.11.24l4.53,2.65s.02.01.05.02c.02,0,.04,0,.05,0s.04,0,.05,0h.02s.03-.02.03-.02l4.55-2.59c.08-.05.13-.14.11-.24-.17-1.03-.68-2-1.44-2.72Zm.95,2.63l-4.04,2.3v-4.07c.78-.07,1.49-.5,1.91-1.17.31.18.6.39.86.63.65.61,1.1,1.43,1.27,2.3Zm-6.42-2.93c.42.67,1.13,1.1,1.91,1.17v4.07l-4.03-2.36c.19-.87.65-1.68,1.31-2.29.25-.23.52-.42.81-.59Zm3.87-.21c-.39.58-1.03.92-1.73.92s-1.34-.34-1.73-.92c.55-.24,1.13-.36,1.73-.36s1.18.12,1.73.36Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m12.49,13.42c1.77,0,3.22-1.44,3.22-3.22,0-.25-.03-.5-.09-.75-.01-.06-.05-.11-.1-.14-.05-.03-.11-.04-.17-.03s-.11.05-.14.1c-.03.05-.04.11-.03.17.05.21.08.43.08.64,0,1.52-1.24,2.76-2.76,2.76s-2.75-1.24-2.75-2.76c0-.21.02-.42.07-.61.03-.12-.05-.25-.17-.28-.12-.03-.25.05-.28.17-.05.23-.08.48-.08.72,0,1.77,1.44,3.22,3.22,3.22Z"
			})] })
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "color",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "m16.17,9.2h-.22c-.02-1.89-1.56-3.41-3.45-3.41s-3.43,1.53-3.45,3.41h-.17c-.17,0-.31.14-.31.31s.14.31.31.31h7.3c.17,0,.31-.14.31-.31s-.14-.31-.31-.31Zm-5.09-2.42l.23.59c.06.16.24.24.4.17.08-.03.14-.09.17-.16.03-.08.04-.16,0-.24l-.24-.61c.55-.17,1.16-.17,1.71,0l-.24.6c-.03.08-.03.16,0,.24s.09.13.17.16c.15.06.34-.02.4-.17l.23-.58c.86.5,1.4,1.41,1.41,2.41h-5.67c.01-1,.56-1.92,1.42-2.42Z"
			})
		})
	]
});
export default SvgOperatingSm;
